__turbopack_context__.v({
  "active": "styles-module__D9qcPG__active",
  "galleryButton": "styles-module__D9qcPG__galleryButton",
  "heart": "styles-module__D9qcPG__heart",
  "iconButton": "styles-module__D9qcPG__iconButton",
  "iconButtonWrapper": "styles-module__D9qcPG__iconButtonWrapper",
  "likeButton": "styles-module__D9qcPG__likeButton",
  "text": "styles-module__D9qcPG__text",
});
